export default "__VITE_ASSET__Cv028aEt__"